/* src/app/modules/agent/pages/property-list/components/my-builder-project/upload-project-brochure/upload-project-brochure.component.scss */
.brochure-header ion-header {
  box-shadow: none;
}
.brochure-header-inner {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 16px 12px;
  background: var(--ion-color-secondary-shade);
}
.brochure-header-left {
  display: flex;
  align-items: center;
  gap: 12px;
}
.brochure-header-icon-box {
  width: 38px;
  height: 38px;
  border-radius: 10px;
  background: rgba(255, 255, 255, 0.18);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}
.brochure-header-icon-box ion-icon {
  font-size: 20px;
  color: #fff;
}
.brochure-header-kicker {
  display: block;
  font-size: 10px;
  font-weight: 600;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: rgba(255, 255, 255, 0.65);
  line-height: 1;
  margin-bottom: 2px;
}
.brochure-header-title {
  display: block;
  font-size: 16px;
  font-weight: 700;
  color: #fff;
  line-height: normal;
}
.brochure-close-btn {
  background: rgba(255, 255, 255, 0.15);
  border: none;
  border-radius: 50%;
  width: 34px;
  height: 34px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: background 0.2s;
  flex-shrink: 0;
}
.brochure-close-btn ion-icon {
  font-size: 20px;
  color: #fff;
}
.brochure-close-btn:hover {
  background: rgba(255, 255, 255, 0.28);
}
.brochure-content {
  --background: #f4f6fb;
}
.brochure-body {
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 16px;
}
.brochure-section {
  background: #fff;
  border-radius: 16px;
  padding: 16px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.06);
}
.section-label-row {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-bottom: 14px;
}
.section-label-icon {
  font-size: 16px;
  color: var(--ion-color-secondary-shade);
}
.section-label-text {
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: var(--ion-color-secondary-shade);
}
.upload-drop-zone {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  border: 2px dashed rgba(var(--ion-color-secondary-shade-rgb, 60, 90, 130), 0.28);
  border-radius: 14px;
  padding: 28px 16px;
  cursor: pointer;
  transition: border-color 0.2s, background 0.2s;
  background: #f8faff;
}
.upload-drop-zone:hover {
  border-color: var(--ion-color-secondary-shade);
  background: rgba(var(--ion-color-secondary-shade-rgb, 60, 90, 130), 0.05);
}
.drop-zone-icon-wrap {
  width: 56px;
  height: 56px;
  border-radius: 50%;
  background: rgba(var(--ion-color-secondary-shade-rgb, 60, 90, 130), 0.1);
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 4px;
}
.drop-zone-icon {
  font-size: 28px;
  color: var(--ion-color-secondary-shade);
}
.drop-zone-title {
  font-size: 14px;
  font-weight: 600;
  color: #2c3e50;
}
.drop-zone-hint {
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 12px;
  color: #8a99b0;
}
.drop-zone-hint ion-icon {
  font-size: 13px;
}
.browse-files-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  margin-top: 12px;
  width: 100%;
  padding: 10px;
  border-radius: 10px;
  border: 1.5px solid var(--ion-color-secondary-shade);
  background: transparent;
  color: var(--ion-color-secondary-shade);
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.2s, color 0.2s;
}
.browse-files-btn ion-icon {
  font-size: 16px;
}
.browse-files-btn:hover {
  background: var(--ion-color-secondary-shade);
  color: #fff;
}
.file-preview-card {
  display: flex;
  align-items: center;
  gap: 12px;
  background: #f0f4ff;
  border-radius: 12px;
  padding: 12px 14px;
  border: 1.5px solid rgba(var(--ion-color-secondary-shade-rgb, 60, 90, 130), 0.2);
}
.file-preview-icon-wrap {
  width: 44px;
  height: 44px;
  border-radius: 10px;
  background: var(--ion-color-secondary-shade);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}
.file-type-icon {
  font-size: 22px;
  color: #fff;
}
.file-preview-info {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 2px;
}
.file-preview-name {
  font-size: 13px;
  font-weight: 600;
  color: #1e2d40;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.file-preview-meta {
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 11px;
  color: #6b7f99;
}
.file-preview-meta ion-icon {
  font-size: 12px;
}
.file-remove-btn {
  background: #fff0f0;
  border: 1.5px solid #f8c8c8;
  border-radius: 8px;
  width: 34px;
  height: 34px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: background 0.2s;
  flex-shrink: 0;
}
.file-remove-btn ion-icon {
  font-size: 17px;
  color: #e74c3c;
}
.file-remove-btn:hover {
  background: #ffd6d6;
}
.existing-file-card {
  display: flex;
  align-items: center;
  gap: 12px;
  background: #f0faf4;
  border-radius: 12px;
  padding: 12px 14px;
  border: 1.5px solid rgba(39, 174, 96, 0.25);
}
.existing-file-icon-wrap {
  position: relative;
  width: 44px;
  height: 44px;
  flex-shrink: 0;
}
.existing-doc-icon {
  font-size: 44px;
  color: #27ae60;
}
.existing-check-icon {
  position: absolute;
  bottom: -4px;
  right: -4px;
  font-size: 18px;
  color: #27ae60;
  background: #fff;
  border-radius: 50%;
}
.existing-file-info {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 2px;
}
.existing-file-label {
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: #27ae60;
}
.existing-file-name {
  font-size: 12px;
  font-weight: 600;
  color: #1e2d40;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.download-btn {
  display: flex;
  align-items: center;
  gap: 5px;
  background: #27ae60;
  border: none;
  border-radius: 9px;
  padding: 8px 12px;
  color: #fff;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  white-space: nowrap;
  transition: background 0.2s;
  flex-shrink: 0;
}
.download-btn ion-icon {
  font-size: 15px;
}
.download-btn:hover {
  background: #219150;
}
.no-file-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  padding: 20px 12px;
  text-align: center;
}
.no-file-icon {
  font-size: 40px;
  color: #c8d3e0;
  margin-bottom: 4px;
}
.no-file-label {
  display: block;
  font-size: 13px;
  font-weight: 600;
  color: #8a99b0;
}
.no-file-hint {
  display: block;
  font-size: 11px;
  color: #b0bcc8;
}
.brochure-footer {
  background: #fff;
  box-shadow: 0 -2px 12px rgba(0, 0, 0, 0.07);
  border-top: none;
}
.brochure-footer-inner {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 10px;
  padding: 12px 16px;
}
.footer-btn {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 10px 18px;
  border-radius: 10px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  border: none;
  transition: background 0.2s, opacity 0.2s;
}
.footer-btn ion-icon {
  font-size: 16px;
}
.footer-btn:disabled {
  opacity: 0.45;
  cursor: not-allowed;
}
.btn-cancel {
  background: #f0f3f7;
  color: #5a6a80;
}
.btn-cancel:hover:not(:disabled) {
  background: #e2e8f0;
}
.btn-upload {
  background: var(--ion-color-secondary-shade);
  color: #fff;
}
.btn-upload:hover:not(:disabled) {
  filter: brightness(1.1);
}
/*# sourceMappingURL=upload-project-brochure.component.css.map */
